import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03951953"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_20B" }, " 정말 탈퇴하시겠습니까? ", -1))
const _hoisted_3 = { class: "btn_groups" }
const _hoisted_4 = { class: "delete_container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_20B" }, " 탈퇴 완료 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_message" }, [
  /*#__PURE__*/_createTextVNode(" 탈퇴 처리가 완료되었습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 더 좋은 서비스로 기다릴게요 언제든 다시 돌아오세요! ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "withdrawal_ch",
    src: "/assets/image/withdrawal_ch.png",
    srcset: "/assets/image/withdrawal_ch@2x.png 2x,/assets/image/withdrawal_ch@3x.png 3x"
  })
], -1))
const _hoisted_8 = {
  class: "btn_groups",
  style: {"margin-top":"0px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "white_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss('cancel')))
        }, " 아니오 "),
        _createElementVNode("div", {
          class: "blue_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss('confirm')))
        }, " 네, 탈퇴하겠습니다. ")
      ])
    ], 512), [
      [_vShow, _ctx.modalType === 'withdrawalInfo']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "blue_btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss('close')))
        }, " 확인 ")
      ])
    ], 512), [
      [_vShow, _ctx.modalType === 'withdrawalDone']
    ])
  ], 64))
}